import {AppRoutes, LocalStorageKeys} from "./constants";

const defaultIntendedUrl = AppRoutes.home.path;

export const getToken = () => window.localStorage.getItem(LocalStorageKeys.AuthToken);
export const setToken = token => {
  token
    ? window.localStorage.setItem(LocalStorageKeys.AuthToken, token)
    : window.localStorage.removeItem(LocalStorageKeys.AuthToken);
};

export const getPersistedDisplayUsers = () => {
  let persisted = window.localStorage.getItem(LocalStorageKeys.DisplayUsers);
  return !persisted ? null : JSON.parse(persisted);
};
export const setPersistedDisplayUsers = token => {
  token
    ? window.localStorage.setItem(LocalStorageKeys.DisplayUsers, JSON.stringify(token))
    : window.localStorage.removeItem(LocalStorageKeys.DisplayUsers);
};

export const getIntendedUrl = () => window.localStorage.getItem(LocalStorageKeys.IntendedUrl) || defaultIntendedUrl;

export const setIntendedUrl = url => {
  url
    ? window.localStorage.setItem(LocalStorageKeys.IntendedUrl, url)
    : window.localStorage.removeItem(LocalStorageKeys.IntendedUrl);
};
